import React, { useEffect, useState } from "react";
import classes from "./Pagintation.module.scss";
import { Header, flexRender, Table } from "@tanstack/react-table";
import { LastPage as LastPageIcon, FirstPage as FirstPageIcon, NavigateNext as NavigateNextIcon, NavigateBefore as NavigateBeforeIcon } from "@mui/icons-material";
import { User, TableParams } from "../../../types/index";
import { setUserToLocalStorage } from "../../../lib/localStorageManager";
import { useRecoilState, useResetRecoilState } from "recoil";
import { userState } from "../../../states/userState";
import {
  backgroundColor,
  foreColor,
  foreColorCode,
  foreColorOnMouseOver,
} from "../../../commons/colors";
type Url = {
  name: string;
  url: string;
};

const Pagination = ({
  table,
  pageSize,
  setPageSize,
  isActive,
  setIsActive,
}: // pageSize,
// setPageSize,
{
  table: Table<any>;
  pageSize: number;
  setPageSize: (pageSize: number) => void;
  isActive: boolean;
  setIsActive: (isActive: boolean) => void;
}) => {
  const [user, setUser] = useRecoilState<User>(userState);
  const [toggle, setToggle] = useState<boolean>(false);
  const [isHovered, setIsHovered] = useState(false);
  // ページジャンプ用のstate
  // const [jumpPage, setJumpPage] = React.useState<string>("");
  //ページネーションスタイル
  const getPaginationButtonStyle = (pageIndex: number) => {
    return {
      backgroundColor:
        table.getState().pagination.pageIndex === pageIndex
          ? foreColorCode(user?.mode ?? "lite")
          : "",
      color:
        table.getState().pagination.pageIndex === pageIndex
          ? user?.mode === "lite"
            ? "#F0F2F5"
            : "#202226"
          : foreColorCode(user?.mode ?? "lite"),
      padding: "0 0.5em 0 0.5em",
      margin: "0 0.2em 3px 0.2em",
      //   width: "10px",
      cursor: "pointer",
    };
  };
  //表示情報
  const {
    getState,
    setState,
    setPageIndex,
    getCanPreviousPage,
    previousPage,
    getCanNextPage,
    nextPage,
    firstPage,
    lastPage,
    getPageCount,
    getFilteredRowModel, // フィルタ適用後の行モデルを取得
  } = table;
  const { pageIndex, pageSize: currentPageSize } = getState().pagination;
  const totalRows = getFilteredRowModel().rows.length; // フィルタ適用後の総行数

  // 表示範囲の計算
  const startRow = pageIndex * currentPageSize + 1;
  const endRow = Math.min((pageIndex + 1) * currentPageSize, totalRows);
  //ページジャンプ
  const handleOnFocusPageJump = () => {
    setUser((prevUser: User) => {
      const updatedUser = {
        ...prevUser,
        tableParams: {
          ...prevUser.tableParams,
          junmpPage: "",
        },
      };
      setUserToLocalStorage(updatedUser);
      return updatedUser;
    });
  };
  const handleOnChangePageJump = (e: React.ChangeEvent<HTMLInputElement>) => {
    let pageNumber = e.target.value ? Number(e.target.value) - 1 : 0;
    if (pageNumber < 0) {
      pageNumber = 0;
    }
    // const pageString = e.target.value ? e.target.value : "";
    const pageCount = getPageCount();
    let junmpNumber = pageNumber;
    if (pageNumber >= pageCount) {
      junmpNumber = pageCount > 0 ? pageCount - 1 : 0;
    }
    console.log("pageString", junmpNumber);
    // setJumpPage(pageString);
    table.setPageIndex(junmpNumber);
    setUser((prevUser: User) => {
      const updatedUser = {
        ...prevUser,
        tableParams: {
          ...prevUser.tableParams,
          junmpPage: String(junmpNumber + 1),
          selectedPage: junmpNumber + 1,
        },
      };
      setUserToLocalStorage(updatedUser);
      return updatedUser;
    });
  };
  const setLastPageIndex = () => {
    const pageCount = getPageCount(); // 総ページ数を取得
    const pageIndex = table.getState().pagination.pageIndex;
    console.log("確認!pageIndex", pageIndex, "pageCount", pageCount);
    if (pageIndex >= pageCount) {
      let lastPageIndex = pageCount > 0 ? pageCount - 1 : 0; // 最後のページインデックス（0ベース）
      setPageIndex(lastPageIndex); // ページインデックスを最後のページに設定
      setUser((prevUser: User) => {
        const updatedUser = {
          ...prevUser,
          tableParams: {
            ...prevUser.tableParams,
            selectedPage: lastPageIndex + 1, // 人間が読むためのページ数は1ベース
            junmpPage: (lastPageIndex + 1).toString(),
          },
        };
        setUserToLocalStorage(updatedUser);
        return updatedUser;
      });
      table.setPageIndex(lastPageIndex);
    }
  };
  useEffect(() => {
    //クリック操作であったら
    console.log("toggle", toggle);
    if (toggle) {
      setToggle(false);

      setLastPageIndex();
      return;
    }
  }, [toggle]);

  useEffect(() => {
    // カラムフィルタが変更されたときに実行される
    if (isActive === true) {
      setLastPageIndex();
    }
  }, [table.getState().columnFilters]);

  useEffect(() => {
    // table.setPageIndex(0);
    console.log(
      "user.tableParamsEnd",
      user.tableParams,
      "pageIndex",
      table.getState().pagination.pageIndex
    );
  }, [user.tableParams.selectedPage]);
  return (
    <div className={classes.rootContainer}>
      {/* ページネーション */}
      <div className={classes.editArea}>
        <div className={classes.pagination}>
          {/* First */}
          <button
            onClick={() => {
              table.firstPage();
              setUser((prevUser) => {
                const updatedUser = {
                  ...prevUser,
                  tableParams: {
                    ...prevUser.tableParams,
                    selectedPage: 1,
                    junmpPage: "1",
                  },
                };
                setUserToLocalStorage(updatedUser);
                return updatedUser;
              });
            }}
            disabled={!table.getCanPreviousPage()}
          >
            <FirstPageIcon sx={foreColor(user?.mode ?? "lite")} />
          </button>
          {/* Prev */}
          <button
            disabled={!table.getCanPreviousPage()}
            onClick={() => {
              table.previousPage();
              setUser((prevUser: User) => {
                const updatedUser = {
                  ...prevUser,
                  tableParams: {
                    ...prevUser.tableParams,
                    selectedPage: table.getState().pagination.pageIndex,
                    junmpPage: table.getState().pagination.pageIndex.toString(),
                  },
                };
                setUserToLocalStorage(updatedUser);
                return updatedUser;
              });
            }}
          >
            <NavigateBeforeIcon sx={foreColor(user?.mode ?? "lite")} />
          </button>
          <div>
            {table.getState().pagination.pageIndex > 0 && (
              <div
                style={getPaginationButtonStyle(
                  table.getState().pagination.pageIndex - 1
                )}
                onClick={() => {
                  table.setPageIndex(table.getState().pagination.pageIndex - 1);
                  setUser((prevUser: User) => {
                    const updatedUser = {
                      ...prevUser,
                      tableParams: {
                        ...prevUser.tableParams,
                        selectedPage: table.getState().pagination.pageIndex,
                        junmpPage: table
                          .getState()
                          .pagination.pageIndex.toString(),
                      },
                    };
                    setUserToLocalStorage(updatedUser);
                    return updatedUser;
                  });
                }}
              >
                {table.getState().pagination.pageIndex}
              </div>
            )}
            <div
              style={getPaginationButtonStyle(
                table.getState().pagination.pageIndex
              )}
              onClick={() =>
                table.setPageIndex(table.getState().pagination.pageIndex)
              }
            >
              {table.getState().pagination.pageIndex + 1}
            </div>

            {table.getState().pagination.pageIndex <
              table.getPageCount() - 1 && (
              <div
                style={getPaginationButtonStyle(
                  table.getState().pagination.pageIndex + 1
                )}
                onClick={() => {
                  table.setPageIndex(table.getState().pagination.pageIndex + 1);
                  setUser((prevUser: User) => {
                    const updatedUser = {
                      ...prevUser,
                      tableParams: {
                        ...prevUser.tableParams,
                        selectedPage: table.getState().pagination.pageIndex + 2,
                        junmpPage: (
                          table.getState().pagination.pageIndex + 2
                        ).toString(),
                      },
                    };
                    setUserToLocalStorage(updatedUser);
                    return updatedUser;
                    return updatedUser;
                  });
                }}
              >
                {table.getState().pagination.pageIndex + 2}
              </div>
            )}
          </div>
          {/* Next */}
          <button
            disabled={!table.getCanNextPage()}
            onClick={() => {
              table.nextPage();
              setUser((prevUser: User) => {
                const updatedUser = {
                  ...prevUser,
                  tableParams: {
                    ...prevUser.tableParams,
                    selectedPage: table.getState().pagination.pageIndex + 2,
                    junmpPage: (
                      table.getState().pagination.pageIndex + 2
                    ).toString(),
                  },
                };
                setUserToLocalStorage(updatedUser);
                return updatedUser;
              });
            }}
          >
            <NavigateNextIcon sx={foreColor(user?.mode ?? "lite")} />
          </button>
          {/* Last */}
          <button
            className="border rounded p-1"
            onClick={() => {
              table.lastPage();
              setUser((prevUser: User) => {
                const updatedUser = {
                  ...prevUser,
                  tableParams: {
                    ...prevUser.tableParams,
                    selectedPage: table.getPageCount(),
                    junmpPage: table.getPageCount().toString(),
                  },
                };
                setUserToLocalStorage(updatedUser);
                return updatedUser;
              });
            }}
            disabled={!table.getCanNextPage()}
          >
            <LastPageIcon sx={foreColor(user?.mode ?? "lite")} />
          </button>
        </div>
        {/* ページジャンプ */}
        <div className={classes.jumpPage}>
          <input
            type="number"
            id="pageJump"
            //   defaultValue={table.getState().pagination.pageIndex + 1}
            onChange={handleOnChangePageJump}
            onFocus={handleOnFocusPageJump}
            value={user.tableParams.junmpPage}
            style={{
              ...foreColor(user?.mode ?? "lite"),
              ...backgroundColor(user?.mode ?? "lite"),
              boxShadow:
                user?.mode === "lite"
                  ? "0px 0px 3px 1px #898b92"
                  : "0px 0px 3px 1px black",
            }}
          />
          <p
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={
              isHovered
                ? foreColorOnMouseOver(user?.mode ?? "lite")
                : foreColor(user?.mode ?? "lite")
            }
          >
            <label htmlFor="pageJump">頁に移動</label>
          </p>
        </div>
      </div>
      <div className={classes.displayArea}>
        {/* ページサイズ */}
        <div className={classes.pageSize}>
          <p
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={
              isHovered
                ? foreColorOnMouseOver(user?.mode ?? "lite")
                : foreColor(user?.mode ?? "lite")
            }
          >
            <label htmlFor="displaySize">表示件数</label>
          </p>
          <select
            // value={user.tableParams.selectedDisplayNumber} //ページサイズ
            value={pageSize}
            id="displaySize"
            style={{
              ...foreColor(user?.mode ?? "lite"),
              ...backgroundColor(user?.mode ?? "lite"),
              boxShadow:
                user?.mode === "lite"
                  ? "0px 0px 3px 1px #898b92"
                  : "0px 0px 3px 1px black",
            }}
            onChange={(e) => {
              table.setPageSize(parseInt(e.target.value));
              setPageSize(parseInt(e.target.value));
              setToggle(true);
              setUser((prevUser: User) => {
                const updatedUser = {
                  ...prevUser,
                  tableParams: {
                    ...prevUser.tableParams,
                    selectedDisplayNumber: parseInt(e.target.value),
                  },
                };
                setUserToLocalStorage(updatedUser);
                return updatedUser;
              });
              e.currentTarget.blur();
            }}
          >
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={75}>75</option>
            <option value={100}>100</option>
          </select>
        </div>
        <div className={classes.filterAll}>
          <input
            style={{
              ...foreColor(user?.mode ?? "lite"),
              ...backgroundColor(user?.mode ?? "lite"),
              boxShadow:
                user?.mode === "lite"
                  ? "0px 0px 3px 1px #898b92"
                  : "0px 0px 3px 1px black",
            }}
            className={
              user?.mode === "lite" ? classes.inputLite : classes.inputDark
            }
            placeholder="ｷｰﾜｰﾄﾞ絞り込み"
            // value={(table.getGlobalFilter() as string) ?? ""}
            value={user.tableParams.keywords}
            onChange={(e) => {
              table.setGlobalFilter(e.target.value);
              setToggle(true);
              setUser((prevUser) => {
                const updatedUser = {
                  ...prevUser,
                  tableParams: {
                    ...prevUser.tableParams,
                    keywords: e.target.value,
                  },
                };
                setUserToLocalStorage(updatedUser);
                return updatedUser;
              });
              // setLastPageIndex();
            }}
          />
        </div>
        <div
          className={classes.displayRange}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={
            isHovered
              ? foreColorOnMouseOver(user?.mode ?? "lite")
              : foreColor(user?.mode ?? "lite")
          }
        >
          {`${startRow}-${endRow} 件 / ${totalRows}件`}
        </div>
      </div>

      {/* 表示範囲と総データ数の表示 */}
    </div>
  );
};

export default Pagination;
